@if (isExpanded) {
    <div class="flex flex-col bg-white px-10px sm:px-20px md:px-30px py-20px dropdown-scroll">
        @if (hasInstallations) {
            @if (isSingleInstallationView) {
                <form [formGroup]="formGroup">
                    <div class="flex flex-col" formArrayName="installations">
                        @for (installation of installationControls; track installation) {
                            <app-customer-relation-entry
                                [installation]="installation"
                                mode="single"
                            ></app-customer-relation-entry>
                        }
                    </div>
                </form>
            } @else {
                <form [formGroup]="formGroup">
                    <mat-radio-group formArrayName="installations" class="flex flex-col gap-20px sm:gap-30px">
                        @for (installation of installationControls; track installation) {
                            <app-customer-relation-entry
                                mode="radio"
                                [installation]="installation"
                                [isBusiness]="isBusiness"
                                [isSelected]="selectedItemId === installation.id"
                                (select)="onSelectInstallation($event)"
                            ></app-customer-relation-entry>
                        }
                    </mat-radio-group>
                </form>
            }
        } @else {
            <div class="mb-30px" translate="userProfile.customerRelations.noRelationsFound"></div>
        }
    </div>
}
